import { render, staticRenderFns } from "./sale_preord.vue?vue&type=template&id=2f7d6d89&scoped=true&"
import script from "./sale_preord.vue?vue&type=script&lang=js&"
export * from "./sale_preord.vue?vue&type=script&lang=js&"
import style0 from "./sale_preord.vue?vue&type=style&index=0&id=2f7d6d89&scoped=true&lang=less&"
import style1 from "./sale_preord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d6d89",
  null
  
)

export default component.exports